import * as React from 'react';

import { SlDropdown, SlMenu } from '@shoelace-style/shoelace/dist/react';
import { PlanType, TeamRole } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { Badge } from '~shared/components/Badge';
import { SmallButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/micro';

import { TeamSettingMenuItem } from './components';
import { Setting } from './components/Setting';
import { mapSettingToText } from './helpers';

export interface Props {
  canInvite: Array<TeamRole>;
  setCanInvite: (newSetting: Array<TeamRole>) => void;
  currentPlan: PlanType;
  canChangeInvite: boolean;
}

export function CanInviteSetting({
  canInvite,
  setCanInvite,
  canChangeInvite,
  currentPlan,
}: Props) {
  const isOrg = [PlanType.Organization, PlanType.Complete].includes(
    currentPlan
  );

  return (
    <Setting
      name={
        <Setting.Name>
          {translate('Invite Permission')}
          {!isOrg ? (
            <div className="flex flex-col justify-center items-center">
              <Badge tone="pro">ORG</Badge>
            </div>
          ) : null}
        </Setting.Name>
      }
      description={
        <Setting.Description>
          {translate(
            'Only roles with permission can invite other team members.'
          )}
        </Setting.Description>
      }
    >
      <Setting.Control>
        <SlDropdown>
          <div slot="trigger" className="grid">
            <SmallButton
              isDisabled={!isOrg || !canChangeInvite}
              appearance="grey-outline"
              suffix={<IconChevron />}
            >
              <span className="font-600 whitespace-no-wrap">
                {mapSettingToText(canInvite)}
              </span>
            </SmallButton>
          </div>
          <SlMenu
            onSlSelect={(evt: Event) => {
              evt.preventDefault();
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const detail = (evt as any).detail;
              const newValue = JSON.parse(detail.item.value) as Array<TeamRole>;

              setCanInvite(newValue);
            }}
          >
            <TeamSettingMenuItem
              value={JSON.stringify([
                TeamRole.Admin,
                TeamRole.Member,
                TeamRole.Owner,
              ])}
            >
              <TeamSettingMenuItem.Content>
                {mapSettingToText([
                  TeamRole.Admin,
                  TeamRole.Member,
                  TeamRole.Owner,
                ])}
              </TeamSettingMenuItem.Content>
            </TeamSettingMenuItem>
            <TeamSettingMenuItem value={JSON.stringify([TeamRole.Admin])}>
              <TeamSettingMenuItem.Content>
                {mapSettingToText([TeamRole.Admin])}
              </TeamSettingMenuItem.Content>
            </TeamSettingMenuItem>
          </SlMenu>
        </SlDropdown>
      </Setting.Control>
    </Setting>
  );
}
